import PropTypes from 'prop-types'
import withStyles from 'beam/dist/styles'
import { withTranslation } from 'react-i18next'

const styles = theme => ({
  silenceEvent: {
    textAlign: 'center',
    margin: theme.spacing(0, 1),
    height: 21,
    position: 'relative',
    zIndex: 1,
    '&:before': {
      content: '""',
      display: 'block',
      position: 'absolute',
      top: '50%',
      left: 0,
      transform: 'translate3d(0, -50%, 0)',
      height: 1,
      width: '100%',
      borderBottom: `1px solid ${theme.palette.divider}`,
      zIndex: -1,
    },
  },
  silenceLabel: {
    padding: theme.spacing(0, 1),
    ...theme.typography.body2,
    backgroundColor: theme.palette.background.default,
  },
  silenceDuration: {
    position: 'absolute',
    right: 0,
    top: '50%',
    transform: 'translateY(-50%)',
    padding: theme.spacing(0, 0, 0, 0.5),
    ...theme.typography.caption,
    backgroundColor: theme.palette.background.default,
  },
})

const SilenceEvent = ({ duration, classes, t }) => (
  <div className={classes.silenceEvent}>
    <span className={classes.silenceLabel}>{t('silence')}</span>
    <span className={classes.silenceDuration}>{`${Math.round(duration / 1000)} s`}</span>
  </div>
)

SilenceEvent.propTypes = {
  duration: PropTypes.number.isRequired,
  classes: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
}

export default withTranslation()(withStyles(styles)(SilenceEvent))
